<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Fuel type - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">
            <div class="form-group">
                <label for="fueltype">Fuel type</label>
                <input type="text" 
                class="form-control" 
                id="fueltype" 
                placeholder="Fuel type"
                v-model="fueltype">
                <div class="invalid-feedback" v-if="errors.fueltype">{{ errors.fueltype[0] }}</div>
            </div>
            <div class="form-group">
                <label for="fuelCostPerL">Fuel cost/L</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="fuelCostPerL" 
                placeholder="Fuel cost/L"
                v-model="fuelCostPerL">
                <div class="invalid-feedback" v-if="errors.fuelCostPerL">{{ errors.fuelCostPerL[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as fuelTypeService from '../../services/fuelType.service';
    export default {
        name:"ModalFuelTypeNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                fueltype:'',
                fuelCostPerL:'',
            }
        },
        methods:{
            ...mapActions(['fetchFuelTypeAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('fueltype',this.fueltype);
                formData.append('fuelCostPerL',this.fuelCostPerL);
            try{
                await fuelTypeService.add(formData);
                this.hideModal();
                this.fetchFuelTypeAll();

                messageService.fnSweetAlertSuccessToast('Fuel type - new', 'added successfully');

                this.fueltype = '';
                this.fuelCostPerL = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Fuel type - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Fuel type - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>